//import {axiosClient} from '../../main'
import Vue from 'vue'
//import axios from '../../http/axios/index.js'

export default {
  addPlaceholder ({ commit }, placeholder) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('/placeholders/add/', {placeholder})
        .then((response) => {
          commit('ADD_PLACEHOLDER', Object.assign(placeholder, { key: response.data.data.key}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPlaceholders ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/placeholders/all')
        .then((response) => {
          commit('SET_PLACEHOLDER', response.data.data.placeholders)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updatePlaceholder ({ dispatch }, placeholder) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('/placeholders/add/', {placeholder})
        .then((response) => {
          //commit('UPDATE_PRODUCT', response.data.data.products)
          dispatch('fetchPlaceholders')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removePlaceholder ({ commit }, placeholderKey) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.delete(`/placeholders/remove/${placeholderKey}`)
        .then((response) => {
          commit('REMOVE_PLACEHOLDER', placeholderKey)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
